import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@src/components/core/core-component-imports';

const MidnightVideoCameraIcon = ({ className }) => {
  return (
    <Image
      fileName='icon_videocam.svg'
      className={className}
      alt='video camera icon'
    />
  );
}

MidnightVideoCameraIcon.propTypes = {
  /**
   * any classes you'd like to add to the image
   */
  className: PropTypes.string,
};

export default MidnightVideoCameraIcon;
